import React, { useEffect, useState } from "react";
import { Chart, registerables } from "chart.js";
import { cn } from "../../../../utils/useFunctions";
import {
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_BLUE_12,
  STYLE_PDF_TEXT_NORMAL_10,
} from "../../styles/pdf.style";
import { useUserStore } from "../../../../_store/userStore";
import api from "../../../../api/api.main";
import { calculateBasicLiquidityRatio } from "../../../../functions/Balance/basic-liquidity-ratio";
import { calculateDebtToTotalAssets } from "../../../../functions/Balance/debt-to-total-assets";
import { SumDebtPersonalValue } from "../../../../functions/Balance/sumValueBalance";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../../functions/Balance/sumProperty";
import numeral from "numeral";
// import { Wallet } from "lucide-react";

// Register Chart.js components
Chart.register(...registerables);

// Chart titles
const chartTitles = [
  "อัตราส่วนสภาพคล่องพื้นฐาน",
  "อัตราส่วนหนี้สินต่อทรัพย์สิน",
  "อัตราส่วนการชำระหนี้ต่อรายรับ",
  "อัตราส่วนการออม",
  "อัตราส่วนการลงทุน",
];

// สร้างตารางและกราฟเปรียบเทียบอัตราส่วนย้อนหลัง โดยให้ข้อมูลแต่ละปีผ่าน owner กลางของสูตรก่อนแสดงผล
const AnalysisTableThree = () => {
  const userData = useUserStore((state) => state.userData);

  const [allData, setAllData] = useState([]);

  const [ReturnInsurance, setReturnInsurance] = useState([
    [{}],
    [{}],
    [{}],
    [{}],
  ]);

  //======================================== สภาพคล่องพื้นฐาน ========================================//
  // คำนวณข้อมูลย้อนหลังด้วย owner กลาง เพื่อไม่ให้ aggregate รายจ่ายเก่ารวมเงินออมหรือลงทุนในตัวหาร
  const checkProperty = (formBL) => {
    const { ratio } = calculateBasicLiquidityRatio({ balanceData: formBL });

    return Number(parseFloat(ratio).toFixed(2) || 0);
  };

  //======================================== หนี้สินต่อสินทรัพย์ ========================================//
  const getDebttoTotalAsset = (balanceData, index) => {
    const propertyInvestLists =
      balanceData?.property_invest_list?.length > 0
        ? balanceData?.property_invest_list
        : [];

    return calculateDebtToTotalAssets({
      balanceData,
      addInvest: propertyInvestLists,
      returnInsurance: ReturnInsurance[index],
    }).ratio;
  };

  //======================================== ชำระหนี้สินต่อรายรับ ========================================//
  const getDebttoSalary = (formBL) => {
    let sum = 0;

    const debtPermonth =
      formBL?.sum_debt_short_permonth + formBL?.sum_debt_long_permonth;
    const salaryPermonth = formBL?.salary_propotion
      ? formBL?.salary_propotion / 12
      : 0;
    sum = salaryPermonth > 0 ? (debtPermonth / salaryPermonth) * 100 : 0;
    return sum;
  };

  //======================================== การออม ========================================//
  const getConservation = (formBL) => {
    let sum = 0;
    if (formBL?.sum_expenses_invest_saving) {
      sum = formBL?.sum_expenses_invest_saving;
    }
    const finalResult = sum > 0 ? (sum / formBL?.salary_propotion) * 100 : 0;
    return finalResult;
  };

  //======================================== การลงทุน ========================================//
  const getInvest = (balanceData, index) => {
    let sum = 0;
    if (
      SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(
          balanceData?.property_invest_list,
          ReturnInsurance[index]
        ) +
        sumDebtInvest(balanceData) >
      0
    ) {
      sum =
        balanceData?.net_wealth > 0
          ? ((SumDebtPersonalValue(balanceData) +
              sumCapitalInvest(
                balanceData?.property_invest_list,
                ReturnInsurance[index]
              ) +
              sumDebtInvest(balanceData)) /
              balanceData?.net_wealth) *
            100
          : 0;
    }
    return sum;
  };

  // Table data
  const tableData = [
    {
      name: "อัตราส่วนสภาพคล่องพื้นฐาน",
      values: [
        `${
          allData[0]?.balanceData
            ? `${numeral(checkProperty(allData[0]?.balanceData)).format(
                "0[.]00"
              )} เท่า`
            : "-"
        } `,
        `${
          allData[1]?.balanceData
            ? `${numeral(checkProperty(allData[1]?.balanceData)).format(
                "0[.]00"
              )} เท่า`
            : "-"
        } `,
        `${
          allData[2]?.balanceData
            ? `${numeral(checkProperty(allData[2]?.balanceData)).format(
                "0[.]00"
              )} เท่า`
            : "-"
        } `,
        `${
          allData[3]?.balanceData
            ? `${numeral(checkProperty(allData[3]?.balanceData)).format(
                "0[.]00"
              )} เท่า`
            : "-"
        } `,
      ],
    },
    {
      name: "อัตราส่วนหนี้สินต่อทรัพย์สิน",
      values: [
        `${
          getDebttoTotalAsset(allData[0]?.balanceData, 0)
            ? `${getDebttoTotalAsset(allData[0]?.balanceData, 0)?.toFixed(2)} %`
            : "-"
        }`,
        `${
          getDebttoTotalAsset(allData[1]?.balanceData, 1)
            ? `${getDebttoTotalAsset(allData[1]?.balanceData, 1)?.toFixed(2)} %`
            : "-"
        }`,
        `${
          getDebttoTotalAsset(allData[2]?.balanceData, 2)
            ? `${getDebttoTotalAsset(allData[2]?.balanceData, 2)?.toFixed(2)} %`
            : "-"
        }`,
        `${
          getDebttoTotalAsset(allData[3]?.balanceData, 3)
            ? `${getDebttoTotalAsset(allData[3]?.balanceData, 3)?.toFixed(2)} %`
            : "-"
        }`,
      ],
    },
    {
      name: "อัตราส่วนการชำระหนี้ต่อรายรับ",
      values: [
        `${
          getDebttoSalary(allData[0]?.balanceData)
            ? `${numeral(getDebttoSalary(allData[0]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
        `${
          getDebttoSalary(allData[1]?.balanceData)
            ? `${numeral(getDebttoSalary(allData[1]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
        `${
          getDebttoSalary(allData[2]?.balanceData)
            ? `${numeral(getDebttoSalary(allData[2]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
        `${
          getDebttoSalary(allData[3]?.balanceData)
            ? `${numeral(getDebttoSalary(allData[3]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
      ],
    },
    {
      name: "อัตราส่วนการออม",
      values: [
        `${
          getConservation(allData[0]?.balanceData)
            ? `${numeral(getConservation(allData[0]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
        `${
          getConservation(allData[1]?.balanceData)
            ? `${numeral(getConservation(allData[1]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
        `${
          getConservation(allData[2]?.balanceData)
            ? `${numeral(getConservation(allData[2]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
        `${
          getConservation(allData[3]?.balanceData)
            ? `${numeral(getConservation(allData[3]?.balanceData)).format(
                "0[.]00"
              )} %`
            : "-"
        }`,
      ],
    },
    {
      name: "อัตราส่วนการลงทุน",
      values: [
        `${
          getInvest(allData[0]?.balanceData, 0)
            ? `${numeral(getInvest(allData[0]?.balanceData, 0)).format(
                "0[.]00"
              )} %`
            : "-"
        } `,
        `${
          getInvest(allData[1]?.balanceData, 1)
            ? `${numeral(getInvest(allData[1]?.balanceData, 1)).format(
                "0[.]00"
              )} %`
            : "-"
        } `,
        `${
          getInvest(allData[2]?.balanceData, 2)
            ? `${numeral(getInvest(allData[2]?.balanceData, 2)).format(
                "0[.]00"
              )} %`
            : "-"
        } `,
        `${
          getInvest(allData[3]?.balanceData, 3)
            ? `${numeral(getInvest(allData[3]?.balanceData, 3)).format(
                "0[.]00"
              )} %`
            : "-"
        } `,
      ],
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: dataStorage } = await api.get(
          `/storages/profileAll/${userData?._id}`
        );

        if (dataStorage?.storages?.length < 4) {
          for (let index = dataStorage?.storages?.length; index < 4; index++) {
            dataStorage?.storages.push({});
          }
        }

        setAllData(dataStorage?.storages);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [userData?._id]);

  useEffect(() => {
    if (allData?.length === 0) {
      return;
    }

    allData?.map((item, index) => {
      let tempBalance = item?.balanceData;
      if (!tempBalance) return;
      if (tempBalance) {
        let tempInsuranceReturn = tempBalance?.expenses_fixed_list
          ?.filter(
            (item) => item.options_expenses_fixed === "expenses_insuarant_life"
          )
          ?.map((item) => item.expenses_insuarant_lifes)
          ?.flat();

        let tempBalanceData = {};
        //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

        if (
          tempBalance?.property_invest_list
            ?.map((item) => item.options_property_invest_title)
            .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
          tempInsuranceReturn?.length === 0
        ) {
          // ถ้ามีหัวข้อนี้อยู่แล้ว
          let tempNameList = tempBalance?.property_invest_list
            .find(
              (item) =>
                item?.options_property_invest_title ===
                "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
            )
            ?.invest_other_lists?.filter((item) => item !== null)
            ?.map((item) => item?.title);

          let tempInvestList = tempBalance?.property_invest_list?.map(
            (item) => {
              if (item?.invest_other_lists) {
                let tempData = tempInsuranceReturn
                  ?.map((item2) => {
                    if (!tempNameList?.includes(item2.title))
                      return {
                        amount: item2?.more_details?.policy_surrender_value,
                        created: item2.created,
                        reward_amount_per_year:
                          item?.reward_amount_per_year || 1,
                        target_invest: {},
                        title: item2.title,
                        editable: false,
                      };
                  })
                  .filter((item) => item !== undefined);
                return {
                  ...item,
                  invest_other_lists: [...item.invest_other_lists, ...tempData],
                };
              }
              return item;
            }
          );

          tempBalanceData = tempInvestList;
        } else {
          // ถ้ายังไม่มีหัวข้อนี้อยู่
          let tempInvestList = tempInsuranceReturn?.map((item) => {
            return {
              amount: item?.more_details?.policy_surrender_value,
              created: item.created,
              reward_amount_per_year: item?.reward_amount_per_year || 1,
              target_invest: item?.target_invest || {},
              title: item?.title,
              editable: true,
            };
          });

          tempBalanceData = tempInvestList;
        }
        ReturnInsurance[index] = tempBalanceData;
        setReturnInsurance(ReturnInsurance);
      }
    });
    //==============================================//
  }, [allData]);

  const years = allData?.map((item, index) => {
    if (!item?.createdAt) {
      // return new Date().getFullYear() + 543 ;
      return null;
    }
    const d = new Date(item.createdAt);
    // Convert to Buddhist Era (BE)
    return d.getFullYear() + 543;
  });


  // Data for the charts
  const chartData = {
    years: years, // Example years, replace with actual years if needed
    values: [
      [
        checkProperty(allData[0]?.balanceData),
        checkProperty(allData[1]?.balanceData),
        checkProperty(allData[2]?.balanceData),
        checkProperty(allData[3]?.balanceData),
      ], // อัตราส่วนสภาพคล่องพื้นฐาน
      [
        Number(getDebttoTotalAsset(allData[0]?.balanceData, 0)?.toFixed(2)),
        Number(getDebttoTotalAsset(allData[1]?.balanceData, 1)?.toFixed(2)),
        Number(getDebttoTotalAsset(allData[2]?.balanceData, 2)?.toFixed(2)),
        Number(getDebttoTotalAsset(allData[3]?.balanceData, 3)?.toFixed(2)),
      ], // อัตราส่วนหนี้สินต่อทรัพย์สิน
      [
        getDebttoSalary(allData[0]?.balanceData),
        getDebttoSalary(allData[1]?.balanceData),
        getDebttoSalary(allData[2]?.balanceData),
        getDebttoSalary(allData[3]?.balanceData),
      ], // อัตราส่วนการชำระหนี้ต่อรายรับ
      [
        getConservation(allData[0]?.balanceData),
        getConservation(allData[1]?.balanceData),
        getConservation(allData[2]?.balanceData),
        getConservation(allData[3]?.balanceData),
      ], // อัตราส่วนการออม
      [
        getInvest(allData[0]?.balanceData, 0),
        getInvest(allData[1]?.balanceData, 1),
        getInvest(allData[2]?.balanceData, 2),
        getInvest(allData[3]?.balanceData, 3),
      ], // อัตราส่วนการลงทุน
    ],
  };




  useEffect(() => {
    // Create charts after component mounts
    const charts = [];

    chartTitles.forEach((title, index) => {
      const ctx = document.getElementById(`chart-${index}`);
      if (ctx) {
        // Destroy existing chart if it exists
        const existingChart = Chart.getChart(ctx);
        if (existingChart) {
          existingChart.destroy();
        }


        // Create new chart
        charts.push(
          new Chart(ctx, {
            type: "line",
            data: {
              labels: chartData.years,
              datasets: [
                {
                  label: title,
                  data: chartData.values[index],
                  borderColor: "#0A558C",
                  backgroundColor: "rgba(10, 85, 140, 0.1)",
                  tension: 0.1,
                  pointRadius: 5,
                  pointBackgroundColor: "#0A558C",
                  pointBorderColor: "#fff",
                  pointBorderWidth: 2,
                },
              ],
            },
            options: {
              devicePixelRatio: 2,
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    font: {
                        size: 8,
                        weight: "400",
                      },
                  },
                  grid: {
                    color: "#E5E7EB",
                    display:false
                  },
                },
                x: {
                  grid: {
                    color: "#E5E7EB",
                  },
                  ticks: {
                    font: {
                        size: 8,
                        weight: "400",
                      },
                  },
                },
              },
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  titleColor: "#1F2937",
                  bodyColor: "#1F2937",
                  borderColor: "#E5E7EB",
                  borderWidth: 1,
                  padding: 10,
                  displayColors: false,
                  callbacks: {
                    label: (context) => {
                      let label = context.dataset.label || "";
                      if (label) {
                        label += ": ";
                      }
                      if (context.parsed.y !== null) {
                        label += new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(context.parsed.y);
                      }
                      return label;
                    },
                  },
                },
              },
            },
          })
        );
      }
    });

    // // Cleanup function
    // return () => {
    //   charts.forEach((chart) => {
    //     if (chart) chart.destroy();
    //   });
    // };
  }, [allData,years]);

  function formatToThaiDate(isoString) {
    if (!isoString) return "";
    const d = new Date(isoString);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear() + 543;
    return `${day}/${month}/${year}`;
  }

  const THisYear = new Date().getFullYear() + 543;

  return (
    <div className="bg-blue-50 rounded-xl p-[15px] mt-5 ">
      {/* Header */}
      <div className="bg-white rounded-xl py-[10px] px-[5px] shadow-sm">
        <div className="flex items-center gap-[5px]">
          <img
            src="images/personal-report.png"
            alt="Description"
            width={14}
            height={14}
          />
          <h1 className={cn(STYLE_PDF_TEXT_MEDIUM_11, "font-bold")}>
            ตารางสรุปการวิเคราะห์ทางการเงิน
          </h1>
        </div>
      </div>

      {/* Section Title */}
      <div>
        <h2 className={cn(STYLE_PDF_TEXT_NORMAL_10, "font-bold my-[10px]")}>
          3. อัตราส่วนทางการเงิน
        </h2>
      </div>

      <div className="bg-white rounded-lg shadow-sm">
        {/* Table */}
        <div className="overflow-x-auto mb-6">
          <table className="w-full h-fit rounded-t-[10px] ">
            <thead className="rounded-t-[10px]  ">
              <tr>
                <th
                  className={cn(
                    STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                    " font-semibold text-left  h-full w-fit p-0 "
                  )}
                >
                  <div className="pl-[5px] pb- h-full w-full bg-gray-100 rounded-tl-[10px] border-l-0 border-r-[0.5px] border-t-[0.5px] border-gray-200 ">
                    รายละเอียด
                  </div>
                </th>
                {allData?.map((item, index) => (
                  <th
                    key={index}
                    className={cn(
                      STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                      ` font-semibold text-center text-[10px] p-0 h-full`
                    )}
                  >
                    <div
                      className={cn(
                        `${STYLE_PDF_TEXT_MEDIUM_BLUE_12} border border-l-0 border-b-0`,
                        ` font-semibold text-center text-[10px] h-full w-full bg-gray-100 border-gray-200 ${
                          index === 3
                            ? "rounded-tr-[10px] border-r-[0.5px]"
                            : ""
                        }`
                      )}
                    >
                      {years[index] || THisYear + index}
                      <div
                        className={cn(
                          STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                          "text-[8px]"
                        )}
                      >
                        {years[index] && (
                          <span>
                            แก้ไขข้อมูลล่าสุด {formatToThaiDate(item.createdAt)}
                          </span>
                        )}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* Header Row */}
              <tr className="border-b-[1px] border-b-[#18488A]">
                <td className="p-0 bg-white ">
                  <div className="flex items-center pl-[5px] py-[3px] border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 ">
                    <img
                      src="images/handholdmoneyandhouse.png"
                      alt="Description"
                      width={14}
                      height={14}
                      className="mr-[5px]"
                    />
                    <span
                      className={cn(
                        STYLE_PDF_TEXT_MEDIUM_BLUE_12,
                        "font-semibold text-[9px] text-black whitespace-nowrap"
                      )}
                    >
                      สรุปอัตราส่วนทางการเงิน
                    </span>
                  </div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
                <td className=" p-0 ">
                  <div className="!w-full !h-full border-l-0 border-t-0 border-[0.5px]  border-gray-200 border-b-0 "></div>
                </td>
              </tr>

              {/* Data Rows */}
              {tableData?.map((row, index) => (
                <tr key={index} className="w-full">
                  <td className=" text-[8px] p-0 text-[#00A9A0] font-medium w-fit ">
                    <div className="  h-full p-[1px] pl-[5px] border-l-0 border-t-0 border-[0.5px]">
                      {row.name}
                    </div>
                  </td>
                  {row.values?.map((value, i) => (
                    <td
                      key={i}
                      className=" text-[8px] p-0 text-center text-[#18488A] font-medium"
                    >
                      <div
                        className={cn(
                          " w-full h-full p-[1px] pl-[5px] border-r-[0.5px] border-b-[0.5px]"
                          // { "border-r-0": index === 3 }
                        )}
                      >
                        {value}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Charts Grid */}
        <div className="flex flex-wrap justify-center space-x-[12px]">
          {chartTitles?.map((title, index) => (
            <div key={index} className="bg-white mb-[30px] ">
              <div className="w-[161px] h-[112px]">
                <canvas id={`chart-${index}`}></canvas>
              </div>
              <div className="text-center mt-2 text-teal-600 font-medium text-[8px] ">
                {title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnalysisTableThree;
